export default () => {
  console.log('INIT FAQ');
  let faqHolder = document.querySelector('section[faq]');
  if (faqHolder) {
    let faqFilters = faqHolder.querySelector('[faq-filters]');
    if (faqFilters) {
      let faqFiltersSelected = [];
      let faqItems = faqHolder.querySelector('[faq-items]');
      if (faqItems) {
        let faqDisplayItems = faqItems.querySelectorAll('[faq-cat]');
        let faqFiltersItems = faqFilters.querySelectorAll('[filter-item]');
        faqFiltersItems.forEach((el, i) => {
          el.addEventListener('change', () => {
            console.log(el.checked, el.value);
            if (el.checked) {
              faqFiltersSelected.push(el.value);
            } else {
              if (faqFiltersSelected.includes(el.value)) {
                faqFiltersSelected.forEach((val, i) => {
                  if (val == el.value) {
                    faqFiltersSelected.splice(i, 1);
                  }
                });
              }
            }
            if (faqFiltersSelected.length > 0) {
              faqItems.classList.add('filtered');
              faqDisplayItems.forEach((el) => {
                let found = false;
                faqFiltersSelected.forEach((val) => {
                  console.log(`check  [${val}]`);
                  if (el.getAttribute('faq-cat').indexOf(`[${val}]`) != -1) {
                    found = true;
                    console.log('FOUND');
                  }
                });
                if (found) {
                  el.setAttribute('style', 'display:block !important;');
                } else {
                  el.setAttribute('style', '');
                }
              });
            } else {
              faqItems.classList.remove('filtered');
            }
          });
        });
      }
    }
  }
};
